// import React from 'react';

//image size should be 1200 × 661

import { vibesImg } from "../img/projImgsObj";

const vibesEmailProject = {
  title: "Tivian Vibes Email Templates",
  shortTitle: "vibesemail",
  description:
    "Modernized internal communication for Tivian's 150+ employees.",
  heroImage: vibesImg,
  previewImg: vibesImg,
  skills: ["HTML5", "CSS3", "MJML"],
  introText: [
    {
      index: 0,
      text: "Tivian had a campaign called Vibes, with the goal of regularly capturing employee feedback. I worked with the Design and Engineering teams to modernize the email templates and landing pages for the weekly employee surveys.",
    },
  ],
  imgsParas: [],
  optstyles: "dropshadow",
};

export default vibesEmailProject;
